import { TranslateService } from '@ngx-translate/core';
import { Injectable, Injector } from '@angular/core';
import { map, tap, Observable, of } from 'rxjs';
import { BaseApiService } from './baseapi.service';
import { KeyValueModel } from '../models/keyvalue.model';

@Injectable({
  providedIn: 'root',
})
export class MetadataService extends BaseApiService {
  private countryList: KeyValueModel[] | null = null;
  private provinceList: KeyValueModel[] | null = null;

  constructor(
    protected injector: Injector,
    protected translateService: TranslateService
  ) {
    super(injector);
  }

  getCountryList(): Observable<KeyValueModel[]> {
    const url = `${this.baseApiUrl}/metadata/countries`;
    if (this.countryList) {
      return of(this.countryList);
    } else {
      return this.httpAuthGet(url).pipe(
        map((res) =>
          res && res.data
            ? res.data.map((c: any) => ({
                key: c.code,
                value: c.name,
              }))
            : []
        ),
        tap((data) => (this.countryList = data))
      );
    }
  }

  getProvinceList(inCountryCode: string): Observable<KeyValueModel[]> {
    const url = `${this.baseApiUrl}/metadata/provinces/${inCountryCode}`;
    return this.httpAuthGet(url).pipe(
      map((res) =>
        res && res.data
          ? res.data.map((c: any) => ({
              key: c.code,
              value: c.name,
            }))
          : []
      )
    );
  }

  getOptoutReasons(): Observable<KeyValueModel[]> {
    const url = `${this.baseApiUrl}/Metadata/optout/options`;
    return this.httpAuthGet(url).pipe(
        map((res) =>
          res && res.data
            ? res.data.map((c: any) => ({
                key: c.text,
                value: c.text,
              }))
            : []
        ),
        tap((data) => (this.countryList = data))
      );

  }
}
